import WizardChooseMotivation from '../../components/Wizard/WizardChooseMotivation';
import { setProgressPanelExpanded } from '../../actions/WizardActions';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIEditorPage from 'UIComponents/page/UIEditorPage';
import UIImage from 'UIComponents/image/UIImage';
import UIProgress from 'UIComponents/progress/UIProgress';
import { useEffect } from 'react';
import styled from 'styled-components';
import WizardProgressInfoPanel from '../../components/Wizard/WizardProgressInfoPanel';
// @ts-expect-error Could not find a declaration file for module
import personImageUrl from 'bender-url!../../../images/pngs/Jean_full.png';
import WizardResults from '../../components/Wizard/WizardResults';
import WizardActions from '../../components/Wizard/WizardActions';
import WizardCategories from '../../components/Wizard/WizardCategories';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useDispatch } from 'react-redux';
import WizardTools from '../../components/Wizard/WizardTools';
import WizardTitle from '../../components/Wizard/WizardTitle';
import UsageTracker from '../../utils/UsageTracker';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import { useHistory } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import UILogo from 'UIComponents/image/UILogo';
import UICloseButton from 'UIComponents/button/UICloseButton';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import { SCREENS } from '../../constants/Tracking';
import { useCurrentLearningInterest, useSubmitWizardResults, useWizardProgress, WizardLanguageToggle } from '../../features/wizard';
import useWizard, { useWizardNavigation } from '../../hooks/useWizard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WizardColumns = styled(UIFlex).withConfig({
  displayName: "WizardContainer__WizardColumns",
  componentId: "sc-1ldp2zs-0"
})(["gap:32px;@media (max-width:", "){gap:0;}"], GRID_BREAKPOINT_SMALL);
const WizardColumnLeft = styled(UIBox).withConfig({
  displayName: "WizardContainer__WizardColumnLeft",
  componentId: "sc-1ldp2zs-1"
})(["@media (min-width:", "){}"], GRID_BREAKPOINT_SMALL);
const WizardColumnLeftContent = styled(UIFlex).withConfig({
  displayName: "WizardContainer__WizardColumnLeftContent",
  componentId: "sc-1ldp2zs-2"
})(["padding-right:", "px;"], props => props.isFinalStep ? 0 : 70);
const WizardColumnRight = styled(UIBox).withConfig({
  displayName: "WizardContainer__WizardColumnRight",
  componentId: "sc-1ldp2zs-3"
})(["min-width:0;@media (max-width:", "){width:100%;}@media (min-width:", "){text-align:left;}"], GRID_BREAKPOINT_SMALL, GRID_BREAKPOINT_SMALL);
const SideUIImage = styled(UIImage).withConfig({
  displayName: "WizardContainer__SideUIImage",
  componentId: "sc-1ldp2zs-4"
})(["width:350px;margin:0 auto;"]);
const DashboardContainer = styled.div.withConfig({
  displayName: "WizardContainer__DashboardContainer",
  componentId: "sc-1ldp2zs-5"
})(["padding:20px;@media (max-width:", "){padding:12px;}"], GRID_BREAKPOINT_SMALL);
const WizardEditorPage = styled(UIEditorPage).withConfig({
  displayName: "WizardContainer__WizardEditorPage",
  componentId: "sc-1ldp2zs-6"
})([".wizard-progress-bar{margin:0 -2px;}"]);
const WizardEditorContent = styled(UIFlex).withConfig({
  displayName: "WizardContainer__WizardEditorContent",
  componentId: "sc-1ldp2zs-7"
})(["height:100%;"]);
const HubspotUILogo = styled(UILogo).withConfig({
  displayName: "WizardContainer__HubspotUILogo",
  componentId: "sc-1ldp2zs-8"
})(["width:106px;transform:translateY(1px);"]);
const HubspotUILogoContainer = styled(FormattedReactMessage).withConfig({
  displayName: "WizardContainer__HubspotUILogoContainer",
  componentId: "sc-1ldp2zs-9"
})(["display:flex;flex:1;font-size:24px;align-items:end;gap:8px;color:", ";"], OBSIDIAN);
const WizardScrollable = styled(UIFlex).withConfig({
  displayName: "WizardContainer__WizardScrollable",
  componentId: "sc-1ldp2zs-10"
})(["flex:1;display:flex;overflow:auto;"]);
const TopLogoAndCloseContainer = styled(UIFlex).withConfig({
  displayName: "WizardContainer__TopLogoAndCloseContainer",
  componentId: "sc-1ldp2zs-11"
})(["padding:20px 40px 0 40px;flex:0;align-items:center;"]);
export const WizardCloseButton = styled(UICloseButton).withConfig({
  displayName: "WizardContainer__WizardCloseButton",
  componentId: "sc-1ldp2zs-12"
})(["position:initial;top:initial;right:initial;margin-top:4px;@media (max-width:", "){width:20px;}"], GRID_BREAKPOINT_SMALL);
const WizardContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const {
    goForward,
    goBack
  } = useWizardNavigation();
  const currentLearningInterest = useCurrentLearningInterest();
  const {
    wizardProgress,
    currentStep
  } = useWizardProgress();
  const isFinalStep = currentStep === 'final';
  const hideProgress = currentStep === 'initial';
  const {
    selectedCategoryGroup,
    selectedToolsGroup,
    isToolsSelected
  } = currentLearningInterest;
  const {
    topResults,
    isRequesting,
    resultsUrl,
    resultsCount,
    resultsCountAllTypes,
    resultsCountCertsOnly
  } = useWizard(currentLearningInterest);
  const backClick = () => {
    goBack();
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-back'
    });
  };
  useSubmitWizardResults({
    resultCount: resultsCount,
    wait: isRequesting
  });
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.WIZARD
    });
  }, []);
  const closeWizard = () => {
    history.push('/');
  };
  const setCertsOnly = certsOnly => {
    goForward(certsOnly);
  };
  const openProgressPanelMobile = () => {
    dispatch(setProgressPanelExpanded(true));
  };
  const onClickProgressPanel = () => {
    dispatch(setProgressPanelExpanded(false));
  };
  const onClickCancel = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-cancel'
    });
    closeWizard();
  };
  const renderProgressPanel = () => {
    return /*#__PURE__*/_jsx(WizardProgressInfoPanel, {
      isRequesting: isRequesting,
      languageToggle: /*#__PURE__*/_jsx(WizardLanguageToggle, {
        showMoreContentInEnglishTooltip: resultsCount > 0 || isRequesting ? undefined : true
      }),
      onSetExpanded: expand => dispatch(setProgressPanelExpanded(expand)),
      onStepClick: onClickProgressPanel,
      resultsCount: resultsCount
    });
  };
  const renderWizardResults = () => {
    return /*#__PURE__*/_jsx(WizardResults, {
      catalogUrl: resultsUrl,
      isRequesting: isRequesting,
      onOpenResultsClick: openProgressPanelMobile,
      results: topResults,
      totalResultCount: resultsCount
    });
  };
  const renderWizardMotivation = () => {
    return /*#__PURE__*/_jsx(WizardChooseMotivation, {
      onMotivationClick: setCertsOnly,
      resultCountTotal: resultsCountAllTypes,
      resultCountTotalCertsOnly: resultsCountCertsOnly
    });
  };
  const onSelectOption = option => {
    goForward(option);
  };
  const renderCategories = () => {
    return isToolsSelected ? /*#__PURE__*/_jsx(WizardTools, {
      onOptionSelect: onSelectOption
    }) : /*#__PURE__*/_jsx(WizardCategories, {
      onOptionSelect: onSelectOption
    });
  };
  const renderWizardLeftContent = () => {
    if (isMobile) return null;
    if (hideProgress) {
      return /*#__PURE__*/_jsx(SideUIImage, {
        "data-test-id": "wizard-left-image",
        src: personImageUrl,
        style: {
          float: 'right'
        }
      });
    }
    return renderProgressPanel();
  };
  const renderWizardRightContent = () => {
    switch (currentStep) {
      case 'final':
        return renderWizardResults();
      case 'motivation':
        return renderWizardMotivation();
      default:
        return renderCategories();
    }
  };
  const renderResultsHelperText = () => {
    return isFinalStep && resultsCount > 0 ? /*#__PURE__*/_jsxs("div", {
      className: "text-center",
      "data-test-id": "wizard-results-helper-text",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.wizard.modal.refineresults"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.wizard.modal.savecourses"
      })]
    }) : null;
  };
  const renderLogo = () => {
    return /*#__PURE__*/_jsx(TopLogoAndCloseContainer, {
      children: /*#__PURE__*/_jsx(HubspotUILogoContainer, {
        message: "learningCenter.wizard.logo",
        options: {
          imageElement: /*#__PURE__*/_jsx(HubspotUILogo, {
            name: "hubspot-wordmark"
          })
        }
      })
    });
  };
  const renderWizardTitle = () => {
    return /*#__PURE__*/_jsx(WizardTitle, {
      catGroup: isToolsSelected ? selectedToolsGroup : selectedCategoryGroup,
      isMobile: isMobile
    });
  };
  const hideTitle = isFinalStep && resultsCount < 1;
  return /*#__PURE__*/_jsx(WizardEditorPage, {
    headerComponent: null,
    mainSectionFlush: true,
    mainSectionStyle: {
      marginTop: '-1px'
    },
    scrollDirection: "none",
    children: /*#__PURE__*/_jsxs(WizardEditorContent, {
      align: "stretch",
      direction: "column",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "WIZARD_VIEW_LOADED"
      }), /*#__PURE__*/_jsx(UIProgress, {
        use: isFinalStep ? 'success' : 'warning',
        value: wizardProgress,
        wrapperClassName: 'wizard-progress-bar'
      }), isMobile && !hideProgress && renderProgressPanel(), /*#__PURE__*/_jsxs(WizardScrollable, {
        align: "stretch",
        direction: "column",
        children: [!isMobile && renderLogo(), /*#__PURE__*/_jsx(WizardActions, {
          catalogUrl: resultsUrl,
          onBackLinkClick: backClick,
          onCancelClick: onClickCancel,
          totalResultCount: resultsCount
        }), /*#__PURE__*/_jsxs(DashboardContainer, {
          children: [/*#__PURE__*/_jsxs(WizardColumns, {
            direction: isMobile ? 'column' : 'row',
            children: [/*#__PURE__*/_jsx(WizardColumnLeft, {
              basis: 0,
              grow: 1,
              children: /*#__PURE__*/_jsx(WizardColumnLeftContent, {
                isFinalStep: isFinalStep,
                justify: "end",
                children: /*#__PURE__*/_jsx(UIBox, {
                  children: renderWizardLeftContent()
                })
              })
            }), /*#__PURE__*/_jsxs(WizardColumnRight, {
              basis: 0,
              grow: isFinalStep ? 3 : 1,
              children: [!hideTitle && renderWizardTitle(), renderWizardRightContent()]
            })]
          }), /*#__PURE__*/_jsx(UIFlex, {
            className: "m-top-5",
            justify: 'center',
            children: /*#__PURE__*/_jsx(UIBox, {
              children: renderResultsHelperText()
            })
          })]
        })]
      })]
    })
  });
};
export default WizardContainer;